import React from "react";
import type { SubService } from "../../../types";
import { DataList, ListColumn, ListAction } from "../../shared";
import { Icons } from "../../shared/Icons";

interface SubServicesListViewProps {
  subServices: SubService[];
  onEdit: (subService: SubService) => void;
  onDelete: (subServiceId: number) => void;
  onToggleStatus?: (subServiceId: number) => void;
  loading?: boolean;
}

export const SubServicesListView: React.FC<SubServicesListViewProps> = ({
  subServices,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const columns: ListColumn<SubService>[] = [
    {
      key: "name",
      label: "Sub-serviço",
      width: "3fr",
      render: (subService) => (
        <div>
          <p className="text-sm font-medium text-gray-900 dark:text-white">
            {subService.name}
          </p>
          {subService.description && (
            <p className="text-xs text-gray-500 dark:text-slate-400 truncate max-w-xs">
              {subService.description}
            </p>
          )}
        </div>
      ),
    },
    {
      key: "expirationDays",
      label: "Validade",
      width: "1fr",
      render: (subService) => (
        <span className="text-sm text-gray-900 dark:text-slate-100">
          {subService.expirationDays != null
            ? `${subService.expirationDays} dias`
            : "—"}
        </span>
      ),
    },
    {
      key: "createdAt",
      label: "Criado em",
      width: "1.5fr",
      render: (subService) => (
        <span className="text-sm text-gray-900 dark:text-slate-100">
          {subService.createdAt
            ? new Date(subService.createdAt).toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
            : "N/A"}
        </span>
      ),
    },
  ];

  const actions: ListAction<SubService>[] = [
    {
      label: "Editar sub-serviço",
      icon: <Icons.Edit sx={{ fontSize: 18 }} />,
      onClick: (subService) => onEdit(subService),
      className:
        "p-1.5 text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-950/40 rounded-lg transition-all duration-200",
      title: "Editar sub-serviço",
      disabled: () => loading,
    },
    {
      label: "Excluir sub-serviço",
      icon: <Icons.Delete sx={{ fontSize: 18 }} />,
      onClick: (subService) => onDelete(subService.id),
      className:
        "p-1.5 text-gray-400 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/40 rounded-lg transition-all duration-200",
      title: "Excluir sub-serviço",
      disabled: () => loading,
    },
  ];

  return (
    <>
      <DataList<SubService>
        data={subServices}
        columns={columns}
        actions={actions}
        keyExtractor={(subService) => subService.id}
        emptyMessage="Nenhum sub-serviço encontrado"
        loading={loading}
        onRowClick={(subService) => onEdit(subService)}
      />
    </>
  );
};
